import React from 'react';
import './HomeInfo.css';

import imgCampo from '../assets/quienes_somos1.jpg';
import imgVaca from '../assets/quienes_somos2.jpg';
const QuienesSomosInfo = () => {
  return (
    <div className="home-info-container">
      <div className="quienes-hero">
      <h1>Quiénes Somos</h1>
      </div>

      {/* BLOQUE 1: HISTORIA*/}
      <section className="info-block">
        <div className="info-text">
          <h2>Nuestra Historia</h2>
          <div className="title-underline"></div>
          <p>
             Páscolo es un proyecto que nació con el objetivo de crear un producto regional diferente y apostar al crecimiento del Alto Valle,
             recuperando tierras improductivas e incrementando la producción de alimentos locales.

            
          </p>
          <p>
            Nos ubicamos a la vera de la Ruta 151, cerca de Cinco Saltos, trabajando todos los días en nuestro queso con el sello rionegrino y la ilusión de que, en un futuro,
            llevemos este sello al resto del país.
          </p>
        </div>
        <div className="info-image">
          {/* Reemplazar con la foto real del mapa o del campo */}
          <img 
            src={imgCampo} 
            alt="Ubicación en Cinco Saltos" 
            loading="lazy"
          />
        </div>
      </section>

      {/* BLOQUE 2:*/}
      {/* Agregamos la clase "reverse" para dar vuelta las columnas en PC */}
      <section className="info-block reverse">
        <div className="info-text">
          <h2>Nuestra Filosofía</h2>
          <div className="title-underline"></div>
          <p>
            Nuestra producción es 100% agroecológica y libre de aditivos. Cuidamos nuestro suelo y a nuestros animales rotándolos cuidadosamente en diez hectáreas, alimentándolos con la misma alfalfa que nosotros sembramos y cosechamos.
          </p>
          <p>
            Esta dedicación nos permite especializarnos en un queso Gouda de excelencia, al que le damos nuestra impronta única con variedades ahumadas y saborizadas con pimienta, ají, pesto y pimentón.
          </p>
            </div>
          <div className="info-image">
          <img 
            src={imgVaca} 
            alt="Vacas pastando alfalfa" 
            loading="lazy"
          />
        </div>
      </section>

    </div>
  );
};

export default QuienesSomosInfo;